import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavBar.css'; // You can style it separately

const NavBar = ({ isCustomer }) => {
  // Customer-org users (members of a customer proxy team) get a minimal portal nav
  // — just their own API keys — not the vendor admin toolset.
  if (isCustomer) {
    return (
      <nav className="nav-bar">
        <NavLink exact to="/portal/keys" activeClassName="active">
          My API Keys
        </NavLink>
      </nav>
    );
  }

  return (
    <nav className="nav-bar">
      <NavLink exact to="/consumption" activeClassName="active">
        Consumption Dashboard
      </NavLink>
      <NavLink to="/customer-overview" activeClassName="active">
        Customer Overview
      </NavLink>
      <NavLink to="/issuance-log" activeClassName="active">
        Issuance Log
      </NavLink>
      <NavLink to="/manage-keys" activeClassName="active">
        Issue API Keys
      </NavLink>
      <NavLink to="/products" activeClassName="active">
        Manage Products
      </NavLink>
      <NavLink to="/licensing" activeClassName="active">
        Offline Licensing
      </NavLink>
      <NavLink to="/provisioning-tokens" activeClassName="active">
        Provisioning Tokens
      </NavLink>
      <NavLink to="/admin" activeClassName="active">
        Team Management
      </NavLink>
    </nav>
  );
};

export default NavBar;
